module.exports = __webpack_public_path__ + "static/media/syun_left3ec5c8057a730bb229b010f53b9effd3.webp";